<template>
    <div class="padding__20">
        <div v-if="selectedPet" class="margin__bottom__20">
            <h4  class="weight700">Pet Name</h4>
            <h4>{{selectedPet.Name}}</h4>
        </div>
        <div v-if="selectedAppointmentDateTime" class="margin__bottom__20">
            <h4 class="weight700">Date and Time</h4>
            <h4>{{getDate(selectedAppointmentDateTime.DateTime)}} on {{getTime(selectedAppointmentDateTime.DateTime)}} </h4>
        </div>
        <div class="margin__bottom__20" v-if="selectedPractice">
            <h4 class="weight700">Location</h4>
            <h4>{{selectedPractice.Name}}</h4>
            <h4>{{selectedPractice.Address1}} {{selectedPractice.City}} {{selectedPractice.State}}</h4>
        </div>
        <div  class="margin__bottom__20">
            <h4 class="weight700">Details</h4>
            <h4>{{visitComments}}</h4>
        </div>
        <div class="row margin__top__20">
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__secondary" @click="goBack()">Previous</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__primary pull-right" @click="appointmentBooked">Confirm</button>
            </div>
        </div>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import moment from 'moment';

export default {
    name: "ConfirmationPrompt",
    created() {
        if (!this.checkIfCalendarValidState) {
            this.$router.replace({ name: 'Practices' })
        }
        this.$store.dispatch('SetPageNumber', 6);
    },
    computed: {
        ...mapGetters({
            selectedPractice: 'selectedPractice',
            selectedPet: 'selectedPet',
            selectedAppointmentDateTime: 'selectedAppointmentDateTime',
            visitComments: 'visitComments',
            checkIfCalendarValidState:'checkIfCalendarValidState'
        })
    },
    methods: {
        goBack() {
            this.$router.replace({ name: 'AppointmentCalendar' })
        },
        appointmentBooked() {
            this.$store.dispatch('BookAppointment')
                .then(response => {
                    this.$router.replace({ name: 'Confirmation' })
                },
                error => {
                     this.$router.replace({ name: 'Confirmation' })
                });

        },
        getDate(date) {
            return moment.parseZone(date).format('MMMM Do YYYY');
        },
        getTime(time) {
            return moment.parseZone(time).format('hh:mm A');
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/ConfirmationPrompt.vue